// extracted by css-extract-rspack-plugin
export default {"cls1":"ImpactStatTile-cls1_fsD","cls2":"ImpactStatTile-cls2_b4t ImpactStatTile-cls1_fsD","statStyle-delta_chip":"ImpactStatTile-statStyle-delta_chip_58B"};